class Utils {
  static parseURL (url) {
    let parser = document.createElement('a')
    let searchObject = {}
    let queries
    parser.href = url
    queries = parser.search.replace(/^\?/, '').split('&')
    for (let i = 0; i < queries.length; i++) {
      let split = queries[i].split('=')
      if (split[0]) searchObject[split[0]] = split[1]
    }
    return {
      protocol: parser.protocol,
      host: parser.host,
      hostname: parser.hostname,
      port: parser.port,
      pathname: parser.pathname,
      search: parser.search,
      searchObject: searchObject,
      hash: parser.hash
    }
  }

  static createQuery (params, encode = true) {
    return Object.keys(params).map((key) => {
      let k = encode ? encodeURIComponent(key) : key
      let v = encode ? encodeURIComponent(params[key]) : params[key]
      return `${k}=${v}`
    }).join('&')
  }

  static updateQuery (query, obj, encode = false) {
    Object.keys(obj).map(key => {
      let re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i')
      let value = obj[key]
      value = encode ? encodeURIComponent(value) : value
      if (query.match(re)) {
        query = query.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        let hash = ''
        if (query.indexOf('#') !== -1) {
          hash = query.replace(/.*#/, '#')
          query = query.replace(/#.*/, '')
        }
        let separator = query.indexOf('?') !== -1 ? '&' : '?'
        query = query + separator + key + '=' + value + hash
      }
    })
    return query
  }

  static getCookie (name) {
    let matches = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`))
    return matches ? decodeURIComponent(matches[1]) : undefined
  }

  static getEnv () {
    return window.ENV_VARIABLES
  }

  static setTemporaryStorage (name, value, lifeTime = 10) {
    if (!localStorage.getItem(name)) {
      if (value.length || value) {
        setTimeout(() => {
          localStorage.removeItem(name)
        }, lifeTime * 1000 * 60)
        localStorage.setItem(name, JSON.stringify(value))
      }
    }
  }
}

const parseURL = Utils.parseURL
const getCookie = Utils.getCookie
const createQuery = Utils.createQuery
const updateQuery = Utils.updateQuery
const getEnv = Utils.getEnv()
const setTemporaryStorage = Utils.setTemporaryStorage
export {
  parseURL,
  getCookie,
  createQuery,
  updateQuery,
  getEnv,
  setTemporaryStorage
}



// WEBPACK FOOTER //
// ./src/services/Utils/index.js